<template>
  <button
    class="count-button"
    type="button"
    :class="{ active }"
    v-on="$listeners">
    +{{ count }}
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
.count-button {
  display: flex;
  align-items: center;
  color: $grey05;

  border: none;
  background-color: transparent;
  
  &.active {
    color: $l-blue;
  }
}
</style>